import axios from "axios";
import { url } from "../../../../../env";

// P0.3: deja evidencia de que el cliente autorizó la consulta a buró de
// crédito (los checkboxes isTrueInfo / acceptTermsConditions de
// FormLeasing.jsx). Se llama SIEMPRE antes de getBuroInfo — si se registra
// después de la consulta no sirve de nada. El texto legal vive versionado en
// el backend (App\Support\Buro\TextoConsentimiento), aquí no se manda texto,
// solo se pide que quede registrado.
export const registrarConsentimientoBuro = async () => {
    try {
        const apiUrl = `${url}/consentimientoBuro`;
        const result = await axios.post(apiUrl, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        });

        return result.data;
    } catch (e) {
        // No bloquea el flujo: P0.3 solo registra. Si falla el registro,
        // getBuroInfo debe poder seguir corriendo igual que hoy.
        console.error("Error al registrar consentimiento de buró:", e);
        return e.response ? e.response.status : 500;
    }
}

export const submitFormLeasingInfo = async (data) => {

    try {
        const apiUrl = `${url}/leasing/leasingSaveInfo`;
        const result = await axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        });

        return result.data;
    } catch (e) {
        return e.response ? e.response.status : 500;
    }
}

const removeAccents = (str) => {
    if (!str) return "";
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const getBuroInfo = async (data, selectedTypePerson) => {
    try {
        let requestData = {};
        // Types 1 (PFAE) and 3 (PF) are physical persons; type 2 is moral
        const isPhysical = selectedTypePerson === 1 || selectedTypePerson === 3;
        // RFC source: physical persons use data.rfc; moral uses data.rfcSyntage
        const rfcValue = isPhysical ? (data.rfc || data.rfcSyntage) : data.rfcSyntage;

        if (isPhysical) {
            const day = String(data.birthday.getDate()).padStart(2, '0');
            const month = String(data.birthday.getMonth() + 1).padStart(2, '0');
            const year = data.birthday.getFullYear();

            const formattedDate = `${day}${month}${year}`;

            requestData = {
                "consulta": {
                    "persona": {
                        "domicilios": [
                            {
                                "ciudad": data.city,
                                "codPais": "MX",
                                // El nombre del campo es el del Anexo de Buró para `domicilios[]`,
                                // el mismo que devuelve el reporte PF y que el backend ya parsea
                                // (ApiController::saveDataReport → 'colonia_poblacion').
                                // Sin acentos ni mayúsculas aquí: el backend normaliza todo el
                                // payload en removeAccentsFromBuroPayload().
                                "coloniaPoblacion": data.colonia,
                                "cp": data.zip,
                                "delegacionMunicipio": data.municipio,
                                "direccion1": data.address,
                                "estado": data.estado,
                            }
                        ],
                        "encabezado": {
                            "clavePais": "MX",
                            "claveUnidadMonetaria": "MX",
                            "identificadorBuro": "",
                            "idioma": "SP",
                            "numeroReferenciaOperador": "                         ",
                            "productoRequerido": "007",
                            "tipoConsulta": "I",
                            "tipoContrato": "AL"
                        },
                        "nombre": {
                            "apellidoMaterno": data.maternal,
                            "apellidoPaterno": data.paternal,
                            "primerNombre": data.firstName,
                            "segundoNombre": data.secondName === "" ? null : data.secondName,
                            "rfc": rfcValue,
                            "fechaNacimiento": formattedDate
                        }
                    }
                },
            };
        } else {
            // Construir el objeto de datos para persona moral
            requestData = {
                "persona": {
                    "rfc": data.rfcSyntage,
                    "razonSocial": data.name,
                    "tipoCliente": 1,
                    "domicilio": {
                        "direccion": removeAccents(data.address),
                        "segundaDireccion": data.address2 === "" ? null : removeAccents(data.address2),
                        "codigoPostal": data.zip,
                        "coloniaOPoblacion": removeAccents(data.colonia),
                        "ciudad": removeAccents(data.city).toUpperCase(),
                        "estado": data.estado === "Estado de Mexico" ? "EM" : data.estado == 'Ciudad de Mexico' ? 'CDMX' : removeAccents(data.estado),
                        "paisDeOrigenDelDomicilio": "MX",
                        "alcaldiaOMunicipio": removeAccents(data.municipio).toUpperCase()
                    }
                },
                "firmaDeAutorizacionDelCliente": "S",
                "ambiguedad": "R",
                "referenciaCrediticia": "",
                "claveDeConsolidacion": null,
                "indicadorScore": "S",
                "codigoScore": "011",
                "indicadorVariablesCalifica": "S"
            };
        }
        const res = await axios.get(`${url}/infoBuro`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params: {
                type: isPhysical ? "pf" : "pm",
                data: JSON.stringify(requestData),
            },
        });
        const response = res.data;

        // Usar la URL completa del servidor de desarrollo
        // const baseUrl = window.location.origin; 
        // const response = await axios.post(`${baseUrl}/buro-api/pf/reporte-de-credito/credit-report-api/v1/reporte-de-credito`, requestData, {
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Authorization": "Bearer a115819b-1908-4358-a67a-73e1e4b8ab01",
        //     }
        // });

        // Procesar la respuesta
        return response.data;
    } catch (e) {
        console.error("Error al consultar el buró:", e);
        if (e.response && e.response.data) {
            return {
                error: true,
                status: e.response.status,
                message: e.response.data.message || 'Error al consultar buró',
                error_type: e.response.data.error_type || null,
            };
        }
        return { error: true, status: 500, message: 'Error de conexión al consultar buró' };
    }
}
